<script setup lang="ts">
import SidebarItem from "@/components/MyStudents/Navigation/SidebarItem.vue";
import type { NavigationSectionProps } from "../types.ts";

defineOptions({ name: "CampusInvolvementSection" });

const props = withDefaults(defineProps<NavigationSectionProps>(), {
  showHiddenNav: false,
  showHeader: false,
});

const emit = defineEmits(["menu-item-clicked"]);

const handleMenuItemClick = () => {
  emit("menu-item-clicked");
};
</script>

<template>
  <div data-testid="campus-involvement-section">
    <div v-if="showHeader" class="mt-4" data-testid="campus-involvement-title">
      <h2
          class="font-montserrat font-bold text-university-primary mb-2"
      >
        Campus Involvement
      </h2>
      <hr class="border-t border-gray-475 mb-2" />
    </div>
    <ul class="space-y-2" data-testid="campus-involvement-list">
      <SidebarItem
        v-if="showHiddenNav"
        text="Clubs"
        :router-link="{ name: 'operations-dashboard' }"
        data-test-id="campus-involvement-item-clubs"
        @menu-item-clicked="handleMenuItemClick"
        mui-icon-name="groups_2"
      />
      <SidebarItem
        v-if="showHiddenNav"
        text="Cycles"
        :router-link="{ name: 'operations-dashboard' }"
        data-test-id="campus-involvement-item-cycles"
        @menu-item-clicked="handleMenuItemClick"
        mui-icon-name="cycle"
      />
      <SidebarItem
        v-if="showHiddenNav"
        text="Leadership Roles"
        :router-link="{ name: 'operations-dashboard' }"
        data-test-id="campus-involvement-item-leadership-roles"
        @menu-item-clicked="handleMenuItemClick"
        mui-icon-name="person_celebrate"
      />
      <SidebarItem
        v-if="showHiddenNav"
        text="Meetings & Events"
        :router-link="{ name: 'operations-dashboard' }"
        data-test-id="campus-involvement-item-meetings-events"
        @menu-item-clicked="handleMenuItemClick"
        mui-icon-name="door_open"
      />
    </ul>
  </div>
</template>

<style scoped>

</style>
